import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { fontstyle1, fontstyle3 } from "../../../utils/fonts";
import signinlogo from "../../../assets/signin-dark.png";
import instance from "../../../utils/axios";
import history from "../../../utils/history";

const Profile = () => {
  const [username, setUsername] = useState("");
  const [profile, setProfile] = useState("");
  const id = useParams().id;

  useEffect(() => {
    instance
      .post("/profile", {
        uid: id
      })
      .then((res) => {
        setUsername(res.data.profile.user_name);
        setProfile(
          "https://avatars.dicebear.com/api/initials/" +
            res.data.profile.user_name +
            ".svg"
        );
        document.getElementById("username").value = res.data.profile.user_name;
        document.getElementById("fullname").value = res.data.profile.full_name;
        document.getElementById("email").value = res.data.profile.email;
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const full_name = document.getElementById("fullname").value;
    instance
      .post("/updateprofile", {
        uid: id,
        full_name: full_name
      })
      .then((res) => {
        console.log(res);
        history.go();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="w-full bg-[#150425] rounded-md mb-10">
      <div className="flex items-center justify-evenly p-2 flex-col sm:flex-row">
        <div className="flex flex-col items-center">
          <div
            className="bg-white h-20 w-20 rounded-md"
            style={{
              backgroundImage: `url(${profile})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat"
            }}
          ></div>
          <div className="text-white pt-2" style={fontstyle1}>
            {username}
          </div>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-10">
            <div className=" gap-3 flex flex-col">
              <div>
                <label
                  className=" text-sm leading-tight tracking-normal mb-2 mt-2 text-white"
                  style={fontstyle1}
                >
                  Email
                </label>
                <input
                  readOnly
                  id="email"
                  name="email"
                  type="email"
                  className=" font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border text-black"
                  placeholder="Email"
                  style={fontstyle3}
                />
              </div>

              <div>
                <label
                  className=" text-sm leading-tight tracking-normal mb-2 mt-2 text-white"
                  style={fontstyle1}
                >
                  Username
                </label>
                <input
                  readOnly
                  id="username"
                  name="username"
                  type="text"
                  className="font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border text-black"
                  placeholder="username"
                  style={fontstyle3}
                />
              </div>
            </div>
            <div className="gap-5 flex flex-col">
              <div>
                <label
                  className=" text-sm leading-tight tracking-normal mb-2 mt-2 text-white"
                  style={fontstyle1}
                >
                  Full Name
                </label>
                <input
                  required
                  id="fullname"
                  name="full_name"
                  type="text"
                  className=" font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border text-black"
                  placeholder="Full Name"
                  style={fontstyle3}
                />
              </div>

              <button
                type="submit"
                className="p-2 bg-[#FF834F] w-max text-white rounded pl-5 pr-5 cursor-pointer flex items-center gap-3"
                style={fontstyle1}
              >
                Update
              </button>
            </div>
          </div>
        </form>
        <img
          src={signinlogo}
          alt="signinlogo"
          className="w-56 hidden sm:hidden md:block"
        />
      </div>
    </div>
  );
};

export default Profile;
